import { api } from '../../core/network/api';

/** design/gdd/quests.md — REST surface is entirely the existing, unmodified core `GET /api/quests`/`POST /api/quests/:id/claim`. Plain wrappers, same convention as contracts-api.ts. */

export type QuestType = 'DAILY' | 'WEEKLY' | 'MILESTONE' | 'SEASONAL';
export type QuestStatus = 'ACTIVE' | 'COMPLETED' | 'CLAIMED' | 'EXPIRED';

export interface QuestDefRow {
  id: string;
  slug: string;
  name: string;
  description: string;
  questType: QuestType;
  action: string;
  targetCount: number;
  rewardSoft: number;
  rewardPremium: number;
  rewardXp: number;
}

export interface UserQuestRow {
  id: string;
  questId: string;
  progress: number;
  status: QuestStatus;
  assignedAt: string;
  completedAt: string | null;
  claimedAt: string | null;
  quest: QuestDefRow;
}

export interface QuestClaimResult {
  soft: number;
  premium: number;
  xp: number;
}

export const getActiveQuests = (): Promise<UserQuestRow[]> => api.get('/quests');

export const claimQuestReward = (userQuestId: string): Promise<QuestClaimResult> =>
  api.post(`/quests/${userQuestId}/claim`);
